import { createContext, ReactNode, useContext, useMemo } from 'react'
import { ExerciseFilterStore } from '@entities/exercise/model/filters.store'

export const ExerciseFilterStoreContext = createContext<null | ExerciseFilterStore>(null)

export const useExerciseFilterStore = (): ExerciseFilterStore => {
	const store: ExerciseFilterStore | null = useContext(ExerciseFilterStoreContext)
	if (!store) {
		throw new Error('useExerciseFilterStore must be used within a ExercisesStoreProvider.')
	}
	return store
}

export const ExerciseFilterStoreProvider = ({ children }: { children: ReactNode }) => {
	const store = useMemo(() => new ExerciseFilterStore(), [])

	return (
		<ExerciseFilterStoreContext.Provider value={store}>
			{children}
		</ExerciseFilterStoreContext.Provider>
	)
}
